import React, {FC, PropsWithChildren} from 'react';

import {RendererOf} from '../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {
  PopoverCoordinator,
  PopoverCoordinatorProps,
} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {TooltipCoordinator} from '../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {PermissionCheck, PermissionCheckProps} from '../../../../srcCommon/permissions/permissionCheck';
import {PermissionDenied} from '../../../../srcCommon/permissions/permissionDenied';
import {PermissionDeniedReasonsEnum, PermissionResult} from '../../../helpers/permissionHelpers';

/*
 * Props.
 */

interface PermissionPopoverCoordinatorProps extends PopoverCoordinatorProps, PermissionCheckProps {
  renderDisabledButton: RendererOf<PermissionDeniedReasonsEnum>;
}

/*
 * Component.
 */

export const PermissionPopoverCoordinator: FC<PropsWithChildren<PermissionPopoverCoordinatorProps>> = ({
  namespaces,
  permission,
  offlinePermission,
  bulkActionPermission,
  ...props
}) => (
  <PermissionCheck
    namespaces={namespaces}
    permission={permission}
    offlinePermission={offlinePermission}
    bulkActionPermission={bulkActionPermission}
  >
    {(permissionResult) => renderContent(props, permissionResult)}
  </PermissionCheck>
);

function renderContent(props: PermissionPopoverCoordinatorProps, permissionResult: PermissionResult) {
  const {renderDisabledButton, children} = props;
  if (permissionResult.isAllowed) {
    return <PopoverCoordinator {...props}>{children}</PopoverCoordinator>;
  }

  return (
    <TooltipCoordinator render={() => <PermissionDenied reason={permissionResult.reason} />}>
      {renderDisabledButton(permissionResult.reason)}
    </TooltipCoordinator>
  );
}
